import { useState, useRef, useEffect } from 'react';
import './gridDropDown.css';
import { LayoutGrid } from 'lucide-react';
// import { DownIcon, UpIcon } from './Icons.tsx';
import { Dialog } from "primereact/dialog";
import { toast } from "../../components/Toast/toast.ts"
//import { useLiveViewDataContext } from '../../context/LiveViewDataContext.tsx';

export default function GridDropDown({ gridSize, handleGridSizeChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [rows, setRows] = useState("")
  const [columns, setColumns] = useState("")
  const [gridSizeDialogVisible, setGridSizeDialogVisible] = useState(false)
 // const { data } = useLiveViewDataContext()

  // console.log(data.length)

  const dropdownRef = useRef();
  const gridOptions = [
    { label: '2x2', value: '2x2' },
    { label: '3x3', value: '3x3' },
    { label: '4x4', value: '4x4' },
    { label: '5x5', value: '5x5' },
    { label: 'Custom', value: 'custom' },
  ];

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const handleRowChange = (e) => {
    const inputValue = e.target.value;

    if (/^\d*$/.test(inputValue)) {
      setRows(inputValue === "" ? "" : Number(inputValue)); // Allow empty input and valid number input
    }
  };

  const handleColumnChange = (e) => {
    const inputValue = e.target.value;

    if (/^\d*$/.test(inputValue)) {
      setColumns(inputValue === "" ? "" : Number(inputValue)); // Same for columns
    }
  };

  const handleOptionClick = (value) => {
    if (value === 'custom') {
      setGridSizeDialogVisible(true);
      return;
    }
    const simulatedEvent = { target: { value } }; // Simulate event object with target.value
    handleGridSizeChange(simulatedEvent); // Pass the simulated event to the handler
    setIsOpen(false); // Close the dropdown
  };

  const handleApplyButtonClick = () => {

    if (rows <= 0 || columns <= 0 || isNaN(rows) || isNaN(columns)) {
      toast.error("Please enter valid positive number");
      return;
    }

    if (columns < 2 || columns > 8) {
      toast.error("Columns must be between 2 and 8.");
      return;
    }
  
    if (rows < 1 || rows > 36) {
      toast.error("Rows must be between 1 and 36.");
      return;
    }

    setGridSizeDialogVisible(false);
    handleGridSizeChange({ target: { value: `${rows}x${columns}` } });
   // console.log(gridSize, rows, columns)
  }

  const handleCancelButtonClick = () => {
    setRows("")
    setColumns("")
    setGridSizeDialogVisible(false);
  }

  return (
    <>
      <Dialog   
      style={{ width: "240px", height:"180px" }}
        header="Custom View"
        visible={gridSizeDialogVisible}
        onHide={handleCancelButtonClick}
      >
        <div className="grid-size-dialog-container">
          <div className="grid-size-dialog-label-container">
            <input
              className="gridInput"
              type="text"
              value={rows}
              onChange={(e) => handleRowChange(e)}
            />
            <span className="multiplySymbol"> × </span>
            <input
              className="gridInput"
              type="text"
              value={columns}
              onChange={(e) => handleColumnChange(e)}
            />
          </div>
          <div className="grid-size-dialog-button-container">
            <button
              className="gridButtons"
              onClick={handleApplyButtonClick}
            >
              Apply
            </button>
            <button
              className="gridButtons"
              onClick={handleApplyButtonClick}>
              Cancel
            </button>
          </div>
        </div>
      </Dialog>
      <div className="grid-dropdown-wrapper" ref={dropdownRef}>
        <button
          className="grid-size-btn bg-transparent border-none p-0 cursor-pointer text-[rgb(var(--text-primary))]"
          onClick={() => setIsOpen(!isOpen)}
        >
          <LayoutGrid size={22} />
        </button>
        {isOpen && (
          <div className="grid-dropdown-list">
            {gridOptions.map((opt) => (
              <button
                key={opt.value}
                onClick={() => handleOptionClick(opt.value)} // Only call the function once
                style={{ color: "#333" }}
                className={`grid-dropdown-item ${opt.value === gridSize ? 'active' : ''}`} // Highlight active option
              >
                {opt.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
